import { useSideNav } from 'components/navigation/side_nav/context';
import { Link } from 'react-router-dom';

export const SideNavItemChild = props => {

    const { activeChildId, item } = props;
    const { handleNavigate } = useSideNav();

    const isActive = activeChildId === item.id;

    const handleClick = e => handleNavigate(e, item);

    return (
        <Link
            aria-current={isActive ? 'page' : undefined}
            className={`nav-link p-3 text-decoration-none text-white text-capitalize rounded-2 position-relative side-nav-submenu-item${isActive ? ' active' : ''}`}
            onClick={handleClick}
            to={item.path}
        >
            {item.label}
        </Link>
    );

};